/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { IgniteUUID } from '@shared/types/common';

/**
 * Returns short version of IgniteUUID
 * @param {IgniteUUID} uuid IgniteUUID
 * @example
 * input: id11('47e1fdd72b4-057e5efa-539c-4383-8853-347abeab33da')
 * output: 47E1FDD72B4
 * @returns {string} string
 */
export const id11 = (uuid: IgniteUUID = '') => uuid.substring(0, 11).toUpperCase();
